<template>
	<div >
		<div style="text-align: center;">
			<!--	<p ><span style="font-family: 宋体; font-size: 12.5pt; font-weight: bold">☆☆☆☆☆☆</span></p>-->
				<p><span style="font-family: 宋体; font-size: 23px; font-weight: bold">国专代缴费服务<a href="/static/generationpayment/annualfee.pdf" style="text-decoration:underline;font-size:18px">(海外专利年费报价表)</a></span></p>
			</div>

			<Row>
				<Col span="12">
					<Card  style="text-align: center;">
		                <img src="@/assets/guozhuan/guozhuan1.jpg" alt="" style="width: 100%;">
		            </Card>
				</Col>
				<Col span="12">
					<Card  style="text-align: center;">
		               <img src="@/assets/guozhuan/guozhuan2.jpg"  alt=""   style="width: 100%;">
		            </Card>
				</Col>
			</Row>
			<Row>
				<Col span="12">
					<Card  style="text-align: center;">
		               <img src="@/assets/guozhuan/guozhuan3.jpg"  alt=""   style="width: 100%;">
		            </Card>
				</Col>
				<Col span="12">
					<Card  style="text-align: center;">
		                <img src="@/assets/guozhuan/guozhuan4.jpg"  alt="" style="width: 100%;">
		            </Card>
				</Col>

			</Row>

	</div>
</template>

<script>
	export default {
		name: 'generationpayment',
		data:function(){
			return {
				data:[],
			};
		},
		created:function(){

		},
		components: {
		},
		methods:{
		}
	}
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/view/generationpayment/generationpayment.vue